const PERIODICITY_ICONS_MAP = {
  ['DAILY']: 'time_daily',
  ['WEEKLY']: 'time_weekly',
  ['MONTHLY']: 'time_monthly',
  ['SEMI-ANNUALLY']: 'time_180-days',
  ['ANNUALLY']: 'time_365-days',
  ['SELECTIVELY']: 'basic_choose',
};

const LIMITS = (state, limits) => {
  state.limits = limits;
};

const WRITE_OFF_OPTIONS = (state, options) => {
  state.writeOffOptions = options.map(option => {
    return {
      ...option,
      icon: PERIODICITY_ICONS_MAP[option.periodicity],
      label: 'can.choose',
      active: false,
    };
  });
};

const ACTIVE_WRITE_OFF_OPTION = (state, item) => {
  state.writeOffOptions = state.writeOffOptions.map(option => {
    return {
      ...option,
      label: option.periodicity === item.periodicity ? item.label : 'can.choose',
      active: option.periodicity === item.periodicity ? item.active : false,
    };
  });
};

export default {
  LIMITS,
  WRITE_OFF_OPTIONS,
  ACTIVE_WRITE_OFF_OPTION,
};
